import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Check",
    text: "Submit your interest and see if you're eligible — no obligation, no commitment.",
  },
  {
    n: "02",
    title: "Connect",
    text: "Sit down with Aaron Rodriguez, your local McDonough loan officer, and map out your purchase or refinance.",
  },
  {
    n: "03",
    title: "Close",
    text: "Your 1% lender credit is applied toward qualifying closing costs at closing. Welcome home, hero.",
  },
];

export const Steps = ({ onQualify }) => (
  <section id="how-it-works" data-testid="steps-section" className="relative overflow-hidden bg-[#060D1A] py-28 sm:py-36">
    <div className="grain-overlay" />
    <div className="pointer-events-none absolute right-0 top-0 h-[400px] w-[400px] rounded-full bg-[#132342] blur-[130px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="mb-16">
        <p className="font-mono text-xs font-bold uppercase tracking-[0.3em] text-[#F59E0B]">Chapter 03 — How It Works</p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-[#FAF8F5] sm:text-3xl lg:text-4xl">
          Three steps to your credit.
        </h2>
      </Reveal>
      <div className="grid gap-12 md:grid-cols-3 md:gap-8">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.12}>
            <div data-testid={`step-${s.n}`} className="group border-t-2 border-[#F59E0B]/30 pt-8 transition-colors duration-500 hover:border-[#F59E0B]">
              <span
                className="font-display text-6xl font-black text-transparent transition-colors duration-500 sm:text-7xl"
                style={{ WebkitTextStroke: "1.5px rgba(245,158,11,0.55)" }}
              >
                {s.n}
              </span>
              <h3 className="mt-6 font-display text-xl font-bold uppercase tracking-wide text-[#FAF8F5]">{s.title}</h3>
              <p className="mt-3 max-w-xs text-sm leading-relaxed text-[#FAF8F5]/65 sm:text-base">{s.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.3} className="mt-16">
        <button
          data-testid="steps-qualify-btn"
          onClick={onQualify}
          className="group flex items-center gap-3 rounded-full bg-[#DC2626] px-8 py-4 font-mono text-xs font-bold uppercase tracking-[0.2em] text-white transition-[transform,background-color,box-shadow] duration-300 hover:-translate-y-1 hover:bg-[#B91C1C] hover:shadow-[0_14px_40px_rgba(220,38,38,0.5)]"
        >
          Start Step One Now
          <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
        </button>
      </Reveal>
    </div>
  </section>
);
